<template>
  <table :class="['product-rows', { 'product-rows--use-multiselect': mq('to-medium') && (rows !== undefined && rows.length > 0 )}]">
    <thead>
      <tr>
        <!--
  <th class="product-row__head-remove">
    <div class="product-row__head-inset">
      <oie-base-checkbox v-model="selectAll" is-for="order-history-select-all" :text="mq('to-medium') ? tStatic('cartProductHeaderSelectAllLabel') : null"></oie-base-checkbox>
    </div>
  </th>
    -->

        <th class="product-row__head-image"></th>

        <th class="product-row__head-article-name">
          <div v-epi-edit="'detailsInvoiceRowsArticleNameHeading'" class="product-row__head-inset">
            <span>
              {{ t('detailsInvoiceRowsArticleNameHeading') }}
              <!-- Artikelnamn -->
            </span>
          </div>
        </th>

        <th class="product-row__head-owner_and_machine">
          <div v-epi-edit="'DetailsInvoiceRowsMachineOwnerHeading'" class="product-row__head-inset">
            {{ t('detailsInvoiceRowsMachineOwnerHeading') }}
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'detailsInvoiceRowsArticleCountHeading'" class="product-row__head-inset">
            {{ t('detailsInvoiceRowsArticleCountHeading') }}
            <!-- Antal artiklar -->
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'detailsInvoiceRowsUnitPriceHeading'" class="product-row__head-inset product-row__head-inset--align-right">
            {{ t('detailsInvoiceRowsUnitPriceHeading') }}
          </div>
        </th>

        <th v-if="showDiscountPercentage" class="product-row__head-item-price">
          <div v-epi-edit="'DetailsInvoiceRowsDiscountHeading'" class="product-row__head-inset product-row__head-inset--align-right">
            {{ t('detailsInvoiceRowsDiscountHeading') }}
          </div>
        </th>

        <th class="product-row__head-item-price">
          <div v-epi-edit="'DetailsInvoiceRowsRowSumHeading'" class="product-row__head-inset product-row__head-inset--align-right">
            {{ t('detailsInvoiceRowsRowSumHeading') }}
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, key) in rows" :key="`table-row-${key}`">
        <!--
  <td class="product-row__body-td--checkbox">
    <div class="product-row__body-inset product-row__body-inset--select">
      <oie-base-checkbox v-if="row.url"
                         v-model="selectedRows"
                         :val="row"
                         size="medium"
                         :is-for="`history-details-product-${key}`"></oie-base-checkbox>
    </div>
  </td>
    -->

        <td class="product-row__body-td--image">
          <div class="product-row__body-inset">
            <component
              :is="row.url ? 'a' : 'div'"
              :href="row.url">
              <img
                class="invoice-row-image"
                :src="`https://www.olssonparts.com/productImage/${row.articleNumber}`"
                :alt="row.description"
                :title="row.description"
                @error="handleImageError(row, $event)">
            </component>
          </div>
        </td>

        <td class="product-row__body-td--article">
          <div class="product-row__body-inset product-row__body-inset--article">
            <div class="invoice-row__name">
              <!-- Linked the way an ordered article is in Mina beställningar: name and article number
                   together, styled as the product name rather than as a blue text link (OC-1627). -->
              <component
                :is="row.url ? 'a' : 'div'"
                :href="row.url"
                :class="{ 'product-row__name': row.url }">
                {{ row.itemDescription }}

                <div class="product-row__article-number">
                  {{ t('detailsInvoiceRowsArticleNumberLabel') }} {{ row.articleNumber }}
                </div>
              </component>

              <div v-if="row.comment" class="product-row__article-number">
                {{ t('detailsInvoiceRowsCommentLabel') }} {{ row.comment }}
              </div>
            </div>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('detailsInvoiceRowsMachineOwnerHeading') }}
          </div>

          <div v-if="row.ownerName" class="invoice-row__owner">
            <button :aria-label="`Open machine owner ${row.ownerName}`" @click="handleSelectMachineOwner(row.ownerID)">
              <oie-base-icon icon="user-avatar" size="m"></oie-base-icon>
              {{ row.ownerName }}
            </button>
          </div>

          <div v-if="row.machineName" class="invoice-row__machine">
            <button :aria-label="`Open machine ${row.ownerName}`" @click="handleSelectMachine(row.machineID)">
              <oie-base-icon icon="machine" size="m"></oie-base-icon> {{ row.machineName }}
            </button>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('detailsInvoiceRowsArticleCountHeading') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.quantity }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('detailsInvoiceRowsUnitPriceHeading') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.unitPrice) }}
          </div>
        </td>

        <td v-if="showDiscountPercentage">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('detailsInvoiceRowsDiscountHeading') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPercentage(row.discountPercent) }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('detailsInvoiceRowsRowSumHeading') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.rowSum) }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [myPages],
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectedRows: [],
    unselectedRows: [],
    showDiscountPercentage: false
  }),
  computed: {
    ...mapGetters('myMachines', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines']),
    selectAll: {
      get() {
        const unselectedRows = _.filter(this.rows, (row) => !_.includes(this.selectedRows, row))

        return this.selectedRows.length > 0 && unselectedRows.length === 0
      },
      set(value) {
        if (!value) {
          this.selectedRows = []
        } else {
          this.selectedRows = [...this.rows]
        }
      }
    }
  },
  watch: {
    selectedRows(rows) {
      this.publish('order-history-rows-selection-updated', rows)
    },
    rows: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== null) {
          this.showDiscountPercentage = this.rows.some(row => row.discountPercent > 0)
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions('myMachines', ['getMyMachines', 'getMyMachinesMetaData', 'getVehicles', 'setCurrentMachine', 'setCurrentMachineOwner', 'setMyMachinesFilter']),
    handleImageError(row, event) {
      event.target.src = 'https://www.olssonparts.com/globalassets/missing404/404.png?preset=ProductSmall'
    },
    handleSelectMachineOwner(ownerID) {
      let machineOwnerObject = this.filteredMachineOwners.find(item => item['machineOwnerId'] === parseInt(ownerID))
      this.setCurrentMachineOwner(machineOwnerObject)
      this.goToSubPage(this.navigationOptions.oieMachineOwnerDetails)
    },
    handleSelectMachine(machineID) {
      let machineObject = this.filteredMachines.find(item => item['machineId'] === parseInt(machineID))

      if (!machineObject) {
        for (const machineOwner of this.filteredMachineOwners) {
          machineObject = machineOwner.machines.find(item => item['machineId'] === parseInt(machineID))

          if (machineObject) {
            break
          }
        }
      }

      this.setCurrentMachine(machineObject)
      this.goToSubPage(this.navigationOptions.oieMachineDetails)
    },
    formatPercentage(percentage) {
      if (percentage) {
        return percentage + '%'
      }

      return ''
    }
  }
}
</script>

<style lang="scss">
  .invoice-row__name {
    font-family: Open Sans,sans-serif;
    font-weight: 600;
    font-size: 1rem;
    color: #222;
  }

  .product-row__body-inset {
    min-height: initial !important;
    padding: .825rem !important;
  }

  .invoice-row-image {
    width: 3.75rem;
    height: 3.75rem;
  }

  .invoice-row__owner, .invoice-row__machine {
    display: flex;
    flex-direction: row;
    margin-bottom: .3rem;
  }

  .invoice-row__owner > button > svg, .invoice-row__machine > button > svg {
    margin-right: .3rem;
  }

  .invoice-row__owner > button, .invoice-row__machine > button {
    background-color: transparent;
    color: rgb(0, 136, 200);
    text-decoration: none;
    border: none;
    overflow: hidden;
    white-space: nowrap;
    max-width: 10rem;
    text-overflow: ellipsis;
    align-items: center;
    display: flex;
  }

  .invoice-row__owner > button:hover, .invoice-row__machine > button:hover {
    text-decoration: underline
  }
</style>
